import type { OfferPackage } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'

export const offersPropertyContext = createContext<IOffersContext<OfferPackage>>(defaults as any)

export function OffersPropertyProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      signalRCalcFinishedEventName='PropertyCalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={offersPropertyContext as any}
    >
      {props.children}
    </OffersProvider >
  )
}

export const useOffersPropertyContext = () => {
  const context = useContext(offersPropertyContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOffersPropertyContext must be used within a OffersPropertyProvider!')
  }

  return context
}